import { Injectable } from '@angular/core';

import { AnalyticsBase } from './analytics-base';
import { AnalyticsProps } from './analytics.types';

@Injectable({ providedIn: 'root' })
export class AnalyticsGlobal extends AnalyticsBase {
  public namespace = '';
  public requireViewContext = false;

  public track(evtName: string, evtProps?: AnalyticsProps) {
    super.track(evtName, evtProps);
  }
}
